import React from 'react'
import './Footer.scss'
export default function Footer() {
  return (
    <div className='footer'>
        <p>© 2024 Edusity. All rights reserved.</p>
        <ul>
            <li>Terms of Services</li>
            <li>Privacy Policy</li>
        </ul>
    </div>
  )
}
